export const mergeUridineInosineAndCategories = (degenerateBasesData) => {
  if (degenerateBasesData && Array.isArray(degenerateBasesData.category)) {
    // Grouping deoxyInosine and deoxyUridine
    // Grouping deoxyInosine and deoxyUridine
    const deoxyUridineCategory = degenerateBasesData.category.find(
      (cat) => cat.categoryName === 'deoxyUridine'
    )
    const deoxyInosineCategory = degenerateBasesData.category.find(
      (cat) => cat.categoryName === 'deoxyInosine'
    )

    if (deoxyUridineCategory && deoxyInosineCategory) {
      const groupedCategory = {
        categoryName: 'deoxyNucleosides',
        categoryDisplayName: '_PC_SPEC_UandI', // Refer baseKeyMap of BaseModification.tsx
        order: '1',
        modifications: [
          ...deoxyUridineCategory.modifications,
          ...deoxyInosineCategory.modifications,
        ],
      }

      const filteredCategories = degenerateBasesData.category.filter(
        (cat) =>
          cat.categoryName !== 'deoxyUridine' &&
          cat.categoryName !== 'deoxyInosine'
      )
      return {
        ...degenerateBasesData,
        category: [...filteredCategories, groupedCategory],
      }
    }
  }
  return degenerateBasesData
}
